module.exports = __webpack_public_path__ + "static/Sergei-blur-4237436470951df26f5dc66c9ecdee5c.jpg";